<template>
  <header class="header_area" :class="{ header_area_burger: burgerOpened }">
    <div class="main_menu">
      <nav class="navbar navbar-light navbar-expand-lg">
        <div class="container">
          <div
            class="row align-items-center w-100 mx-4 mx-sm-1 justify-content-between"
          >
            <div class="col-9 col-md-3 col-xl-3 p-0">
              <!-- Brand and toggle get grouped for better mobile display -->
              <a class="navbar-brand logo_h" href="/">
                <icon-logo></icon-logo>
              </a>
            </div>
            <button
              @click="burgerOpened = !burgerOpened"
              class="navbar-toggler pr-0"
              type="button"
            >
              <icon-burger v-if="!burgerOpened"></icon-burger>
              <icon-close v-else :size="14" class="close" />
            </button>
            <div
              class="col-6 col-md-6 col-lg-6 col-xl-6 header-navmenu nav-mob d-none d-lg-block"
            >
              <div>
                <ul class="nav justify-content-center">
                  <li class="nav-item">
                    <a
                      :href="`/screener/${$store.state.market.platform}`"
                      @click.prevent="
                        $router.push(
                          `/screener/${$store.state.market.platform}`
                        )
                      "
                      >{{ $t('header.nav.screener') }}</a
                    >
                  </li>
                  <li class="nav-item d-lg-inline">
                    <a
                      href="/ideas"
                      @click.prevent="$router.push(`/ideas`)"
                      target="_blank"
                      rel="noreferrer"
                      >{{ $t('header.nav.ideas') }}</a
                    >
                  </li>
                  <li class="nav-item d-lg-inline">
                    <a
                      href="/articles"
                      @click.prevent="$router.push(`/articles`)"
                      target="_blank"
                      rel="noreferrer"
                      >{{ $t('header.nav.articles') }}</a
                    >
                  </li>
                  <li class="nav-item d-lg-inline">
                    <a
                      href="/calendar"
                      @click.prevent="$router.push(`/calendar`)"
                      target="_blank"
                      rel="noreferrer"
                      >{{ $t('header.nav.russianIR') }}</a
                    >
                  </li>
                  <li v-if="showRDV" class="nav-item d-md-inline">
                    <a
                      href="https://t.me/AK47pfl"
                      target="_blank"
                      rel="noreferrer"
                      >{{ $t('header.nav.RDV') }}</a
                    >
                  </li>
                </ul>
              </div>
              <site-search
                v-if="false"
                :opened="searchOpened"
                @close="toggleSearch(false)"
              >
              </site-search>
            </div>
            <div
              class="col-3 col-md-3 col-lg-3 col-xl-3 text-right p-0 userbar-navmenu justify-content-end nav-mob d-none d-lg-block"
            >
              <div class="user-bars">
                <user-menu v-if="$store.state.user.email" />
                <login class="order-2 ml-3" v-else />
                <lang-select></lang-select>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <nav
      v-if="burgerOpened"
      class="navbar navbar-light navbar-expand-lg navbar-mobile d-lg-none align-items-start align-items-md-center"
    >
      <div class="container">
        <div
          class="row align-items-center w-100 mx-4 mx-sm-1 justify-content-between d-lg-none"
        >
          <ul class="nav justify-content-center flex-wrap">
            <li class="nav-item mr-4" :class="{ 'col-md-2': !showRDV }">
              <a
                href="#"
                @click.prevent="
                  pushToRouter(`/screener/${$store.state.market.platform}`)
                "
                >{{ $t('header.nav.screener') }}</a
              >
            </li>
            <li class="nav-item mr-4" :class="{ 'col-md-2': !showRDV }">
              <a
                href="/ideas"
                @click.prevent="pushToRouter(`/ideas`)"
                target="_blank"
                rel="noreferrer"
                >{{ $t('header.nav.ideas') }}</a
              >
            </li>
            <li
              class="nav-item d-lg-inline mr-4"
              :class="{ 'col-md-2': !showRDV }"
            >
              <a
                href="#"
                @click.prevent="pushToRouter(`/calendar`)"
                target="_blank"
                rel="noreferrer"
                >{{ $t('header.nav.russianIR') }}</a
              >
            </li>
            <li
              class="nav-item d-lg-inline mr-4"
              :class="{ 'col-md-2': !showRDV }"
            >
              <a
                href="#"
                @click.prevent="pushToRouter(`/articles`)"
                target="_blank"
                rel="noreferrer"
                >{{ $t('header.nav.articles') }}</a
              >
            </li>
            <li v-if="showRDV" class="nav-item d-md-inline mr-0">
              <a
                @click="pushToRouter()"
                href="https://t.me/AK47pfl"
                target="_blank"
                rel="noreferrer"
                >{{ $t('header.nav.RDV') }}</a
              >
            </li>
          </ul>
          <div class="user-bars position-relative">
            <user-menu v-if="$store.state.user.email" />
            <login class="order-md-2 ml-md-3 my-2" v-else />
            <lang-select></lang-select>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import _isUndefined from 'lodash/isUndefined'
import ilogo from '@/components/icons/logo'
import iburger from '@/components/icons/burger'
import iclose from '@/components/icons/close'
import SiteSearch from './SiteSearch'
import LangSelector from './LangSelector'
import UserMenu from './UserMenu'
import Login from './Login.vue'

export default {
  components: {
    'icon-logo': ilogo,
    'site-search': SiteSearch,
    'lang-select': LangSelector,
    'user-menu': UserMenu,
    login: Login,
    'icon-burger': iburger,
    'icon-close': iclose,
  },
  data() {
    return {
      searchOpened: false,
      burgerOpened: false,
    }
  },
  computed: {
    showRDV() {
      return this.$i18n.locale === 'ru'
    },
  },
  methods: {
    toggleSearch(val) {
      this.searchOpened = _isUndefined(val) ? !this.searchOpened : val
    },
    pushToRouter(link) {
      if (link) this.$router.push(link)
      this.burgerOpened = false
    },
  },
}
</script>

<style lang="scss">
.header_area {
  background: #000000;
  z-index: 99999;
  transition: background 0.4s, all 0.3s linear;
  padding: 25px 0;
  height: 80px;
  position: relative;

  padding: 14px 0;
  height: 60px;

  a {
    color: #fff;
  }

  .navbar {
    background: transparent;
    padding: 0px;
    border: 0px;
    border-radius: 0px;

    .container > .row {
      width: 100%;
      padding: 0 !important;
      margin: auto;

      .navbar-toggler {
        height: 32px;
      }
    }

    .logo_h {
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;
      max-width: 200px;

      svg {
        margin-top: -18px;
        position: relative;
        top: 9px;
        max-width: 200px;
        width: 162px;
        height: 40px;

        @media (max-width: 767px) {
          max-width: 90px;
          margin-top: -19px;
          margin-left: -5px;
        }
      }
    }

    .nav {
      margin: 0 !important;
      background-color: #000;
      flex-wrap: nowrap;

      @media (max-width: 576px) {
        padding-top: 8px !important;
        padding-left: 46px !important;
      }

      @media (max-width: 768px) {
        border-bottom: 1px solid #333333;
        padding-bottom: 2px;
        margin-bottom: 20px !important;
        padding-left: 6px;
        width: 100%;
      }

      .nav-item {
        margin-right: 30px;

        @media (max-width: 768px) {
          margin-bottom: 18px;
          width: 100%;
        }

        @media (max-width: 1200px) {
          margin-right: 12px;
        }

        a {
          font-weight: bold;
          font-stretch: normal;
          font-size: 0.8rem;
          line-height: 1.5rem;
          font-family: $primary-font;
          text-transform: capitalize;
          color: #fff;
          padding: 0px;
          display: inline-block;
          @media (max-width: 768px) {
            font-weight: normal;
            font-size: 16px;
          }
        }

        &:hover,
        &.active {
          a {
            color: $primary-color2;
          }
        }

        &:last-child {
          margin-right: 0px;
        }

        &.submenu {
          position: relative;

          ul {
            border: none;
            padding: 0;
            border-radius: 0;
            margin: 0px;
            background: #fff;
            border-radius: 15px !important;
            padding: 30px 30px 20px;
            box-shadow: 0 40px 100px rgba(0, 0, 0, 0.2);
            text-align: left;

            @media (min-width: 1199px) {
              position: absolute;
              top: 120%;
              left: -100%;
              min-width: 400px;
              text-align: left;
              opacity: 0;
              transition: all 300ms ease-in;
              visibility: hidden;
              display: block;
              border: none;

              border-radius: 0px;
            }

            &:after {
              position: absolute;
              bottom: 100%;
              left: 38%;
              content: '';
              width: 10px;
              height: 15px;
              border-bottom: solid 12px #fff;
              border-left: solid 8px transparent;
              border-right: solid 8px transparent;

              @media (max-width: 1199px) {
                bottom: 84%;
                left: 49%;
              }
            }

            &:before {
              content: '';
              width: 0;
              height: 0;
              border-style: solid;
              border-width: 10px 10px 0 10px;
              border-color: #eeeeee transparent transparent transparent;
              position: absolute;
              right: 24px;
              top: 45px;
              z-index: 3;
              opacity: 0;
              transition: all 400ms linear;
            }

            .nav-item {
              display: block;
              float: none;
              margin-right: 0px;
              margin-left: 0px;
              transition: all 0.4s linear;
              margin-bottom: 30px;
              position: relative;
              padding-left: 60px;

              @media (max-width: 1199px) {
                border-bottom: 0;
                text-align: left;
              }

              img {
                margin-right: 10px;
                position: absolute;
                left: 0;
                top: -5px;
              }

              a {
                line-height: 1.875rem;
                color: #2f302c;
                font-size: 1.125rem;
                font-weight: 700;
                text-transform: capitalize;
                transition: all 150ms linear;
                display: block;
                margin-right: 0px;
                border: 0;
                @include transition();

                @media (max-width: 1199px) {
                  border-bottom: 0;
                }
              }

              &:last-child {
                border-bottom: none;
              }

              &:hover a {
                color: $primary-color2;
              }

              &.active {
                .nav-link {
                  color: $primary-color;
                }
              }
            }
          }

          &:hover {
            ul {
              @media (min-width: 992px) {
                visibility: visible;
                opacity: 1;
                top: 100%;
              }

              .nav-item {
                margin-top: 0px;
              }
            }
          }
        }
      }
    }
    .login {
      @media (max-width: 768px) {
        padding-left: 19px;
        margin-bottom: 12px;
      }
    }
    .close {
      color: white;
      opacity: 1;
    }
    .user-bars {
      .theme {
        height: 30px;
      }
      .dropdown-item {
        &:hover {
          color: $primary-color2;
          background: inherit;
          cursor: pointer;
          path {
            stroke: $primary-color2;
          }
        }
        path {
          transition: 0.2s;
        }
      }
    }
  }
  @media (max-width: 576px) {
    height: 36px;
    padding: 4px 0;
    &_burger {
      position: fixed;
      width: 100%;
    }
  }
  @media (max-width: 991px) {
    .navbar-nav {
      background-color: #000000;
    }
  }
  .navbar-mobile {
    width: 100%;
    position: absolute;
    top: 60px;
    padding: 10px 0;
    background: $title-color;
    @media (max-width: 576px) {
      height: calc(100vh - 36px);
      position: fixed;
      top: 36px;
    }
  }
}
</style>
